import React from 'react';
import { useParams } from 'react-router-dom';
import Home from './Home/Home';
import NotFound from './NotFound/NotFound';

export default function RegionHome() {
  const { region } = useParams();
  if (!region || !/^[a-z]{2}$/i.test(region)) {
    return <NotFound />;
  }
  return <Home />;
}
